import { render, staticRenderFns } from "./oldManDetail.vue?vue&type=template&id=de83014a&scoped=true&"
import script from "./oldManDetail.vue?vue&type=script&lang=js&"
export * from "./oldManDetail.vue?vue&type=script&lang=js&"
import style0 from "./oldManDetail.vue?vue&type=style&index=0&id=de83014a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de83014a",
  null
  
)

export default component.exports